import React from 'react';

const Pictogram: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  ...props
}) => {
  return <img height={60} style={{ margin: 6 }} {...props} />;
};

export default Pictogram;
